import { observableValue, useSharableState, view } from '@esui/core';
import { DemoPage, Section, VSection } from '../@demo/utils.js';
import { Textarea } from './index.js';

export const [TextareaDemo] = view('esui-material-textarea-demo', {
  template() {
    const text = useSharableState('');

    return DemoPage(
      Section(
        'Standard',
        Textarea('Standard', text),
        Textarea('Standard Outlined').outlined()
      ),

      Section(
        'Textarea with Character Counter',
        Textarea('Your text').maxLength(18).charCounter(true),
        Textarea('Your text').outlined().maxLength(18).charCounter(true)
      ),

      Section(
        'Textarea with Helper Text',
        Textarea('Your text').helper('Helper text').helperPersistent(),
        Textarea('Your text')
          .outlined()
          .helper('Helper text')
          .helperPersistent()
      ),

      Section(
        'End-aligned',
        Textarea('Your text', observableValue('End-aligned')).endAligned(),
        Textarea('Your text', observableValue('End-aligned'))
          .outlined()
          .endAligned()
      ),
      VSection(
        'Full Width Textarea',
        Textarea('')
          .fullWidth()
          .placeholder('Your text')
          .helper('Helper text')
          .helperPersistent(),

        Textarea('')
          .fullWidth()
          .placeholder('Your text')
          .outlined()
          .helper('Helper text')
          .helperPersistent()
      )
    );
  },
});
